import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StatesLargeData } from 'src/app/_data/states';
import { UsStates } from 'src/app/_data/us-states';
import { ShippingConfig } from 'src/app/_models/configuration-widgets/business-config';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { BusinessSetupProgressService } from 'src/app/_services/business-setup-progress.service';
import { BusinessSetupService } from 'src/app/_services/business-setup.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { CustomersService } from 'src/app/_services/customers.service';
import { GlobalService } from 'src/app/_services/global.service';
import { state } from '@angular/animations';

@Component({
  selector: 'app-shipping-configuration',
  templateUrl: './shipping-configuration.component.html',
  styleUrls: ['./shipping-configuration.component.scss']
})
export class ShippingConfigrationComponent implements OnInit, AfterViewInit {
  @ViewChild('basicShippingComponent') basicShippingComponent: any;
  _global = GlobalService
  shippingConfigurationForm: FormGroup;
  zoneForm: FormGroup;
  shippingData: any;
  @Input() singupBusinessConfig: boolean = true;
    @Output() widgetSaved = new EventEmitter();
  usaStates = UsStates
  singleCountry = [
    {viewValue:'United State',value:'US'},
  ]
  countries = []
  singleZoneName= null
  allStates:any[] = []
  largeStates = StatesLargeData 
  states:any[] = [] 
  dropdownStates:any[] = [] 
  zonesList:any[] = []
  isAddAewZone:boolean = false
  zoneNameExist:boolean = false
  showCityWait=false
  selectedObj:any = null
  selectedState:any = null
  selectedUSPSState:any = null
  
  servicesList:any[] =[
    {viewValue:'Express Mail',value:'express_mail'},
    {viewValue:'Priority Mail',value:'priority_mail'},
    {viewValue:'First Class',value:'first_class'},
    {viewValue:'Ground Advantage',value:'ground_advantage'},
    {viewValue:'Standard Post',value:'standard_post'},
    {viewValue:'Media Mail',value:'media_mail'},
    {viewValue:'Library Mail',value:'library_mail'},
  ]

  constructor(private _fb: FormBuilder,
              public _businessSetupService: BusinessSetupService,
              private _connMessageService: ConnMessageService,
              private _abd: AppBaseDataService,
              private _route: ActivatedRoute,
              private _router: Router,
              private _spinner: NgxSpinnerService,
              private _businessSetupProgressService: BusinessSetupProgressService,

            ) { }

  ngOnInit(): void {
  let countries = []
  countries = this.largeStates.filter((state) => state.country_code === 'US'
  );
  this.states = countries
    this.countries = countries.map((v)=>{
      return{
        id:v.id,
        name:v.name,
        country_id:v.country_id,
        country_code:v.country_code,
        country_name:v.country_name,
        state_code:v.state_code,
        type:v.type
      }
    }).filter(
      (v, i, a) =>
        a.findIndex((t) => t.country_code === v.country_code) === i
    );
    this.getShippingConfig()
    this.initForm()
  }

  ngAfterViewInit(): void {
    // Initialize basic-shipping component when view is ready to load states and data
    if (this.basicShippingComponent) {
      this.basicShippingComponent.initializeComponent();
    }
  }
   addnewZome(){
    this.zoneForm.reset()
     if( this.singleZoneName === null){
      if(!this.f.address.valid || !this.f.phone.valid || !this.f.zipCode.valid || !this.f.city.valid){
        this._connMessageService.showToastMessage(`Add shipping origin!`, 'error')
      }else{
        this.isAddAewZone = true
      }
     }else{
       this._connMessageService.showToastMessage(`Save configurations to add new zone!`, 'error')
     }
   }
   cButtonClick(){
    this.isAddAewZone = false
    this.zoneForm.reset();
   }
  getShippingConfig(){
    try{
      this._abd.showSpinner()
      this._businessSetupService.getShippingConfiguration().subscribe(res=>{
        this._abd.hideSpinner()
        if(res.success){
          this.singleZoneName = null
          this.zonesList = (res.data?.zones ?? []).reverse()
          if(this.zonesList.length > 0){  
            setTimeout(() => {
              this.shippingData = this.zonesList[0]
              this.selectedObj = this.shippingData
              this.setValues(this.shippingData)
            }, 500);
          }
        }
      })
    }
    catch{
      this._abd.hideSpinner()
    }
  }
  setValuesToForm(){
   this.setValues(this.selectedObj)
  }
  get f() {
    return this.shippingConfigurationForm.controls;
  }
  get zF() {
    return this.zoneForm.controls;
  }
  setValues(values:any) { 
    let statesObj = []
    Object.entries(values.states).forEach(([countryCode, stateCodes]:any) => {
      let countryFiltered = this.states.filter(
        (s) => s.country_code.toUpperCase() === countryCode.toUpperCase() && stateCodes.includes(s.state_code)
      );
      statesObj.push(...countryFiltered);
    });
     
    this.shippingConfigurationForm.get('isEnabled').setValue(values?.isEnabled)
    this.shippingConfigurationForm.get('zoneName').setValue(values?.zoneName|| "")
    this.shippingConfigurationForm.get('country').setValue(values?.country|| "US")
    this.shippingConfigurationForm.get('address').setValue(values?.address)
    this.shippingConfigurationForm.get('countries').setValue(values?.countries)
    this.shippingConfigurationForm.get('phone').setValue(values?.phone)
    this.shippingConfigurationForm.get('zipCode').setValue(values?.zipCode)
    this.shippingConfigurationForm.get('city').setValue(values?.city)
    this.shippingConfigurationForm.get('states').setValue(statesObj)
    this.shippingConfigurationForm.get('isEnableFlat').setValue(values?.flatRate?.isEnableFlat)
    this.shippingConfigurationForm.get('flatRate').setValue(values?.flatRate.rate)
    this.shippingConfigurationForm.get('isFlatTaxIncluded').setValue(values?.flatRate?.isTaxIncluded)
    this.shippingConfigurationForm.get('flatTaxRate').setValue(values?.flatRate?.taxRate)
    this.shippingConfigurationForm.get('isEnablePickup').setValue(values?.storePickUp?.isEnablePickup)
    this.shippingConfigurationForm.get('pickupCost').setValue(values?.storePickUp?.pickupCost)
    this.shippingConfigurationForm.get('isPickUpTaxIncluded').setValue(values?.storePickUp?.isTaxIncluded)
    this.shippingConfigurationForm.get('pickUpTaxRate').setValue(values?.storePickUp?.taxRate)
    this.shippingConfigurationForm.get('isEnabledUSPS').setValue(values?.usps?.isEnabledUsps)
    this.shippingConfigurationForm.get('postcode').setValue(values?.usps?.postcode)
    this.shippingConfigurationForm.get('enabledServices').setValue(values?.usps?.enabledServices)
    this.selectedState = values?.state
    //this.selectedUSPSState = values?.usps?.postcode

    const getStates = this.usaStates.find((state) => state.abbreviation == values?.state)
    this.selectedState =getStates
    this.zipcodeUSPSInputEvent(values?.usps?.postcode)
     const upsState = this.usaStates.find((state) => state.abbreviation == values?.usps?.postcode)
    //this.selectedUSPSState = upsState
   
}

zipcodeInputEvent(value: string) {
  if (!value || value.length !== 5) return
  this.showCityWait = true
  this._abd.getCityAndStateInfo(value).subscribe((res: any) => {
    this.showCityWait = false
    if (res.success && res.data.city != undefined) {
      this._businessSetupService.city = res.data.city + '';
      const st = this.usaStates.filter(s => s.abbreviation == res.data.state)
      this._businessSetupService.selectedState = st[0];
      this.selectedState = this._businessSetupService.selectedState
      this.shippingConfigurationForm.patchValue({ city: res.data.city })
      if(this.shippingConfigurationForm.get('postcode').value === ""){
        this.shippingConfigurationForm.get('postcode').setValue(value)
        this.selectedUSPSState = this.selectedState
      }
    } else {
      this._businessSetupService.city = "Invalid zip code"
      this.shippingConfigurationForm.patchValue({ city: "Invalid zip code" })
      this._businessSetupService.selectedState = this.usaStates[0]
      this.selectedState = this._businessSetupService.selectedState     
       if(this.shippingConfigurationForm.get('postcode').value === ""){
        this.shippingConfigurationForm.get('postcode').setValue(value)
        this.selectedUSPSState = this.selectedState
      }
    }
  })
}
zipcodeUSPSInputEvent(value: string) {
  if (!value || value.length !== 5) return

  this._abd.getCityAndStateInfo(value).subscribe((res: any) => {

    if (res.success && res.data.city != undefined) {
      this._businessSetupService.city = res.data.city + '';
      const st = this.usaStates.filter(s => s.abbreviation == res.data.state)
      this.selectedUSPSState = st[0]
      this.shippingConfigurationForm.patchValue({ city: res.data.city })
     
    } else {
      this._businessSetupService.city = "Invalid zip code"
      this.shippingConfigurationForm.patchValue({ city: "Invalid zip code" })
      this.selectedUSPSState = this.usaStates[0]

    }
  })
}

  initForm() {
    this.zoneForm = this._fb.group({
      zoneName:["",Validators.required]
     })
    this.shippingConfigurationForm = this._fb.group({
      isEnabled: [],
      //  Shipping 
      // Shipping Origin
      country:[""],
      address:[this._global.userInfo.businessSetup[0].address],
      phone:[this._global.userInfo.businessSetup[0].phone],
      zipCode:[this._global.userInfo.businessSetup[0].zip],
      city:[this._global.userInfo.businessSetup[0].city],
      // Shipping Zones
      zoneName:[],
      countries:[["US"]],
      states:[[]],
      //  Shipping Methods
       isEnableFlat: [false],
       flatRate: [0],
       isFlatTaxIncluded: [true],
       flatTaxRate: [0],
       isEnablePickup: [false],
       pickupCost: [0],
       isPickUpTaxIncluded: [true],
       pickUpTaxRate: [0],
       isEnabledUSPS: [false],
       postcode: [this._global.userInfo.businessSetup[0].zip],
       uSPSState: [""],
       enabledServices: [[]],

     })
     
     if(this.f.states.value.length == 0){
      const getStates = this.usaStates.find((state) => state.abbreviation == this._global.userInfo.businessSetup[0].state)
      this.selectedState =getStates
     }
     this.setCustomValidator()
  }
  setCustomValidator(){
    this.f.countries.valueChanges.subscribe(val=>{
     this.updatedStates(val)
     })
     this.f.countries.valueChanges.subscribe(val=>{
      this.updatedStates(val)
      })
    this.allValidation(this.f.isEnabled.value)
     this.f.isEnabled.valueChanges.subscribe(val=>{
      this.allValidation(val)
      })
    this.flatRateValidation(this.f.isEnableFlat.value)
     this.f.isEnableFlat.valueChanges.subscribe(val=>{
      this.flatRateValidation(val)
      })
      this.flatTaxIncluded(this.f.isFlatTaxIncluded.value)
     this.f.isFlatTaxIncluded.valueChanges.subscribe(val=>{
      this.flatTaxIncluded(val)
      })
    this.enablePickup(this.f.isEnablePickup.value)
     this.f.isEnablePickup.valueChanges.subscribe(val=>{
      this.enablePickup(val)
      })
      this.pickUpTaxIncluded(this.f.isPickUpTaxIncluded.value)
      this.f.isPickUpTaxIncluded.valueChanges.subscribe(val=>{
        this.pickUpTaxIncluded(val)
      })
      this.usps(this.f.isEnabledUSPS.value)
       this.f.isEnabledUSPS.valueChanges.subscribe(val=>{
        this.usps(val)
        })
  }

  updatedStates(value){
    this.dropdownStates =  this.states.filter(state =>
      value.includes(state.country_code.toUpperCase())
    );
    let dropdownValue = this.shippingConfigurationForm.get('states').value

    let matchedStates = this.dropdownStates.filter(parent =>
      dropdownValue.some(child =>
        parent.country_code === child.country_code && parent.state_code === child.state_code
      )
    );
    this.shippingConfigurationForm.get('states').setValue(matchedStates)
  }
  allValidation(val?:any){
    if(val === true){
      this.f.zoneName.setValidators([Validators.required]);
      this.f.address.setValidators([Validators.required]);
      this.f.phone.setValidators([Validators.required]);
      this.f.zipCode.setValidators([Validators.required]);
      this.f.city.setValidators([Validators.required]);
      this.f.countries.setValidators([Validators.required]);

       } else{
        this.f.zoneName.clearValidators();
        this.f.address.clearValidators();
        this.f.phone.clearValidators();
        this.f.zipCode.clearValidators();
        this.f.city.clearValidators();
        this.f.countries.clearValidators();

       }
       this.f.zoneName.updateValueAndValidity();
       this.f.address.updateValueAndValidity();
       this.f.phone.updateValueAndValidity();
       this.f.zipCode.updateValueAndValidity();
       this.f.city.updateValueAndValidity();
       this.f.countries.updateValueAndValidity();

   }
  flatRateValidation(val?:any){
    if(val === true){
      this.f.flatRate.setValidators([Validators.required]);
      this.f.flatTaxRate.setValidators([Validators.required]);
       } else{
        this.f.flatRate.clearValidators();
        this.f.flatTaxRate.clearValidators();
       }
       this.f.flatRate.updateValueAndValidity();
       this.f.flatTaxRate.updateValueAndValidity();
   }
   flatTaxIncluded(val?:any){
    if(val === false){
      this.f.flatTaxRate.setValidators([Validators.required]);
       } else{
        this.f.flatTaxRate.clearValidators();
       }
       this.f.flatTaxRate.updateValueAndValidity();
   }
   enablePickup(val?:any){
    if(val === true){
      this.f.pickupCost.setValidators([Validators.required]);
      this.f.pickUpTaxRate.setValidators([Validators.required]);
       } else{
        this.f.pickupCost.clearValidators();
        this.f.pickUpTaxRate.clearValidators();
       }
       this.f.pickupCost.updateValueAndValidity();
       this.f.pickUpTaxRate.updateValueAndValidity();
   }
   pickUpTaxIncluded(val?:any){
    if(val === false){
      this.f.pickUpTaxRate.setValidators([Validators.required]);
       } else{
        this.f.pickUpTaxRate.clearValidators();
       }
       this.f.pickUpTaxRate.updateValueAndValidity();
   }
   usps(val?:any){
    if(val === true){
      this.f.postcode.setValidators([Validators.required]);
      this.f.enabledServices.setValidators([Validators.required]);
       } else{
        this.f.postcode.clearValidators();
        this.f.enabledServices.clearValidators();
       }
       this.f.postcode.updateValueAndValidity();
       this.f.enabledServices.updateValueAndValidity();
   }
   saveZoneNew(){
   if(this.doesZoneExist()) return

    if(this.singleZoneName === null){
   this.singleZoneName = this.zoneForm.get('zoneName').value
   
   this.shippingConfigurationForm.get('zoneName').setValue(this.singleZoneName)
   this.isAddAewZone = false
   this.zoneForm.reset()
   this.shippingConfigurationForm.get('countries').setValue(["US"])
   this.shippingConfigurationForm.get('states').setValue([])
   this.shippingConfigurationForm.get('isEnableFlat').setValue(false)
   this.shippingConfigurationForm.get('flatRate').setValue(0)
   this.shippingConfigurationForm.get('isFlatTaxIncluded').setValue(true)
   this.shippingConfigurationForm.get('flatTaxRate').setValue(0)
   this.shippingConfigurationForm.get('isEnablePickup').setValue(false)
   this.shippingConfigurationForm.get('pickupCost').setValue(0)
   this.shippingConfigurationForm.get('isPickUpTaxIncluded').setValue(true)
   this.shippingConfigurationForm.get('pickUpTaxRate').setValue(0)
   this.shippingConfigurationForm.get('isEnabledUSPS').setValue(false)
   this.shippingConfigurationForm.get('enabledServices').setValue([])
    }else{
      this._connMessageService.showToastMessage(`Save configurations to add new zone!`, 'error')
    }

   }
   doesZoneExist() {
    if (!this.zoneForm.get('zoneName').value) return true
    const name = this.zoneForm.get('zoneName').value.trim()
    this.zoneNameExist = true
      if(this.zonesList.length > 0){
        this._spinner.show()
       if(this.zonesList.some(zone => zone.zoneName.toLowerCase() === name.toLowerCase())){
        this.zoneForm.controls['zoneName'].setErrors({ 'zoneExist': true })
        this._spinner.hide()
        this.zoneNameExist = true
        return true
        }else{
          this._spinner.hide()
          this.zoneNameExist = false
         return false
        }
      }
}
       
  saveFn(){

    
    let statesValue = this.shippingConfigurationForm.get('states').value
     let finalObject = {}
     statesValue.forEach(state => {
      const countryCode = state.country_code;
      const stateCode = state.state_code;
    
      if (!finalObject[countryCode]) {
        finalObject[countryCode] = [];
      }
      finalObject[countryCode].push(stateCode);
    });

    const shippingType = this.f.isEnableFlat.value ? 1 : (this.f.isEnabledUSPS.value ? 3 : 2);

    if(this.singleZoneName !== null || this.zonesList.length < 1){
      let shippingValue: any = {
        "zones":[  {
          "isEnabled": this.f.isEnabled.value,
          "zoneName": this.f.zoneName.value,
          "shippingtype": shippingType,
          "country": this.f.country.value || "US" ,
          "address":this.f.address.value ,
          "phone": this.f.phone.value,
          "city": this.f.city.value ,
          "countries": this.f.countries.value,
          "zipCode":this.f.zipCode.value,
          "state": this.selectedState.abbreviation
          ,
          "states": finalObject,
          "isSaved": true,
          "flatRate": {
            "isEnableFlat": this.f.isEnableFlat.value,
            "rate": Number(this.f.flatRate.value),
            "isTaxIncluded": this.f.isFlatTaxIncluded.value,
            "taxRate": Number(this.f.flatTaxRate.value),
        },
        "storePickUp": {
          "isEnablePickup": this.f.isEnablePickup.value,
          "pickupCost": Number(this.f.pickupCost.value),
          "isTaxIncluded": this.f.isPickUpTaxIncluded.value,
          "taxRate": Number(this.f.pickUpTaxRate.value),
      },
      "usps": {
          "isEnabledUsps": this.f.isEnabledUSPS.value,
          "postcode": this.f.postcode.value,
          "enabledServices": this.f.enabledServices.value,
      }

      }]
      }
    try{
      this._abd.showSpinner()
      this._businessSetupService.saveShippingConfiguration(shippingValue).subscribe(res=>{
        if(res.success){
          this.isAddAewZone = false
          this.zoneForm.reset()

          this.getShippingConfig()
          // First-time save — the checklist/topbar "Setup X/Y" count reads shipping completion
          // from BusinessSetupProgressService's cache, which nothing here was invalidating, so
          // it kept showing stale progress until some unrelated action happened to refresh it.
          // markShippingConfigurationSaved() (which also invalidates) rather than plain
          // invalidate() — it's the real "a zone was actually saved" signal, since the backend's
          // own zones[0].isEnabled is true even on an auto-provisioned zone the merchant never
          // touched.
          this._businessSetupProgressService.markShippingConfigurationSaved()

          this._connMessageService.showToastMessage(`Shipping configuration saved successfully!`, 'success')
        }
      })
    }
    catch{
      this._connMessageService.showToastMessage(`Error saving shipping configurations!`, 'error')
      this._abd.hideSpinner()
    }

    }
    else{  
    const index = this.zonesList.findIndex(z => z.id === this.selectedObj.id);

     if (index !== -1) {
      this.zonesList[index] = {
      "isEnabled": this.f.isEnabled.value,
      "id": this.selectedObj.id,
      "zoneName": this.f.zoneName.value,
      "shippingtype": shippingType,
      "country": this.f.country.value,
      "address": this.f.address.value,
      "phone": this.f.phone.value,
      "city": this.f.city.value,
      "countries": this.f.countries.value,
      "zipCode": this.f.zipCode.value,
      "state": this.selectedState?.abbreviation,
      "states": finalObject,
      "isSaved": true,
      "flatRate": {
          "isEnableFlat": this.f.isEnableFlat.value,
          "rate": Number(this.f.flatRate.value),
          "isTaxIncluded": this.f.isFlatTaxIncluded.value,
          "taxRate": Number(this.f.flatTaxRate.value) || 0,
          "id": this.selectedObj?.flatRate?.id,
      },
      "storePickUp": {
          "isEnablePickup": this.f.isEnablePickup.value,
          "pickupCost": Number(this.f.pickupCost.value),
          "isTaxIncluded": this.f.isPickUpTaxIncluded.value,
          "taxRate": Number(this.f.pickUpTaxRate.value) || 0,
          "id": this.selectedObj.storePickUp.id,
      },
      "usps": {
          "isEnabledUsps": this.f.isEnabledUSPS.value,
          "postcode": this.f.postcode.value,
          "enabledServices": this.f.enabledServices.value,
          "userID": this.selectedObj.usps.userID,
          "id": this.selectedObj.usps.id,
      }
  }}

     let zones = this.zonesList.map((v)=>{
      return{
        ...v,
        "shippingtype": shippingType,
        "isEnabled": this.f.isEnabled.value,
        "country": this.f.country.value,
        "address": this.f.address.value,
        "phone": this.f.phone.value,
        "city": this.f.city.value,
        "zipCode": this.f.zipCode.value,
        "state": this.selectedState?.abbreviation,
      }
     })
        let shippingValue: any = {
     "zones":zones
    }
    // if(this.zonesList.length > 1){
      this.selectedObj.id  = null
    // }
 
    try{
      this._abd.showSpinner()
      this._businessSetupService.updateShippingConfiguration(this.selectedObj.id,shippingValue).subscribe(res=>{
        if(res.success){

          this.getShippingConfig()
          this._businessSetupProgressService.markShippingConfigurationSaved()

          this.goToRoute()
          this._connMessageService.showToastMessage(`Shipping configuration saved successfully!`, 'success')
        }else{
          this._connMessageService.showToastMessage(`Error saving shipping configurations!`, 'error')
          this._abd.hideSpinner()
        }
      })
    }
    catch{
      this._connMessageService.showToastMessage(`Error saving shipping configurations!`, 'error')
      this._abd.hideSpinner()
    }
    }

 
  }
  goToRoute() {
    let page:any = null;
    let route = null
  
    this._route.queryParams.subscribe(params => {
      page = params['page']; 
    });
    if(page !== undefined){
      if(page.includes('shipping')){
       this._router.navigate([""])
      }
    }
  }
  cancelButtonClick(){
    this._businessSetupService.showPrintingConfiguration = false
  }

  }
  
